import React from 'react';
import classifications from 'helpers/classifications';
import {
  useMainCategoriesQuery,
  useUpdateClientAccountScoreSettingSubCategoriesMutation,
  useAccountScoreSettingQuery,
} from 'api';

export default ({priority}: {priority: number}) => {
  const {data: {mainCategories = []} = {}} = useMainCategoriesQuery({});
  const {data: {accountScoreSetting = {}} = {}} = useAccountScoreSettingQuery(
    {},
  );
  const selectedCategories =
    accountScoreSetting?.subCategoriesGroupByPriority[`${priority}`]?.map(
      (subCategory: any) => String(subCategory.id),
    ) ?? [];
  const allSelectedCategories =
    accountScoreSetting?.subCategories?.map((subCategory: any) =>
      String(subCategory.id),
    ) ?? [];
  const [updateCategories] =
    useUpdateClientAccountScoreSettingSubCategoriesMutation({});
  return (
    <div className="bg-white rounded-b h-[450px] overflow-y-scroll flex flex-col gap-2">
      <div className="bg-white flex-1 flex flex-col gap-4 rounded-b">
        <div className="bg-white p-4 rounded flex gap-2 flex-1">
          <div className="w-64 overflow-y-scroll overflow-x-hidden relative py-2">
            <div className="w-64 absolute">
              {classifications(mainCategories).map((classification, index) => (
                <div
                  key={classification.name}
                  onClick={() => {
                    const list = document.getElementById('subCategoryList');
                    const current = list.getBoundingClientRect().top;
                    const target = document
                      .getElementById(`classification_list_${index}`)
                      .getBoundingClientRect().top;
                    const diff = target - current;
                    list.scrollBy({
                      top: diff,
                      left: 0,
                    });
                  }}
                  className="cursor-pointer w-64 h-8 flex items-center text-base px-4">
                  <span className="flex-1">{classification.name}</span>
                </div>
              ))}
            </div>
          </div>
          <div
            className="flex-1 overflow-y-scroll overflow-x-hidden relative py-2"
            id="subCategoryList">
            <div className="absolute w-full px-4 flex flex-col gap-8">
              {classifications(mainCategories).map((classification, index) => (
                <section key={classification.name}>
                  <div className="flex items-center gap-2 mb-4">
                    <div className="w-1 h-5 bg-[#222426]" />
                    <h3
                      className="font-bold text-lg m-0"
                      id={`classification_list_${index}`}>
                      {classification.name}
                    </h3>
                  </div>
                  {classification.categories.map((category) => (
                    <div key={category.id} className="mb-8">
                      <label className="flex items-center text-base w-full cursor-pointer">
                        <input
                          type="checkbox"
                          value={category.id}
                          checked={category.subCategories.every((sc) =>
                            selectedCategories.includes(sc.id),
                          )}
                          disabled={accountScoreSetting?.subCategories?.some(
                            (sc) =>
                              sc.mainCategoryId === category.id &&
                              !selectedCategories.includes(String(sc.id)),
                          )}
                          className="form-checkbox h-5 w-5 rounded border-c-border disabled:bg-c-bg disabled:text-c-light cursor-pointer"
                          onChange={(e) => {
                            const arr = e.target.checked
                              ? Array.from(
                                  new Set([
                                    ...selectedCategories,
                                    ...category.subCategories.map(
                                      (sc) => sc.id,
                                    ),
                                  ]),
                                )
                              : selectedCategories.filter(
                                  (id: any) =>
                                    !category.subCategories.some(
                                      (sc) => sc.id === id,
                                    ),
                                );
                            updateCategories({
                              variables: {
                                subCategoryIds: arr,
                                priority,
                              },
                            });
                          }}
                        />
                        <span className="ml-2">
                          {category.displayName}すべて
                        </span>
                      </label>
                      <div className="my-4 pt-4 border-t border-c-border">
                        {category.subCategories.map((subCategory) => (
                          <label
                            key={subCategory.id}
                            className="flex items-center text-base w-full cursor-pointer">
                            <input
                              type="checkbox"
                              value={subCategory.id}
                              className="form-checkbox h-5 w-5 rounded border-c-border disabled:bg-c-bg disabled:text-c-light cursor-pointer"
                              checked={selectedCategories.includes(
                                subCategory.id,
                              )}
                              disabled={
                                allSelectedCategories.includes(
                                  subCategory.id,
                                ) &&
                                !selectedCategories.includes(subCategory.id)
                              }
                              onChange={(e) => {
                                const arr = e.target.checked
                                  ? Array.from(
                                      new Set([
                                        ...selectedCategories,
                                        subCategory.id,
                                      ]),
                                    )
                                  : selectedCategories.filter(
                                      (id: any) => id !== subCategory.id,
                                    );
                                updateCategories({
                                  variables: {
                                    subCategoryIds: arr,
                                    priority,
                                  },
                                });
                              }}
                            />
                            <span className="ml-2">
                              {subCategory.displayName}
                            </span>
                          </label>
                        ))}
                      </div>
                    </div>
                  ))}
                </section>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
